﻿/*
 * Created on Mon Nov 19 2018
 *
 * Copyright (c) 2018 - Francisco Giana <gianafrancisco@gmail.com>
 */
export * from './user';
export * from './pagination';
export * from './aranceles';
export * from './matriculado';
